import { LocaleProps } from "./";

const esES: LocaleProps = {
  connectWallet: "Conecta una billetera",
  disconnect: "Desconectar",
  connected: "Conectado",
  wrongNetwork: "Red incorrecta",
  switchNetworks: "Cambio de red",
  chainNetwork: "Red {{ CHAIN }}",
  copyToClipboard: "Copiar al portapapeles",
  copyCode: "Copiar código",
  moreInformation: "Más información",
  back: "Atrás",
  close: "Cerrar",
  or: "o",
  more: "Más",
  tryAgain: "Intentar de nuevo",
  tryAgainQuestion: "¿Intentar de nuevo?",
  dontHaveTheApp: "¿No tienes la aplicación?",
  scanTheQRCode: "Escanea el código QR",
  useModal: "Utilizar Modal",
  installTheExtension: "Instalar la extensión",
  getWalletName: "Obtén {{ CONNECTORNAME }}",
  otherWallets: "Otras billeteras",
  learnMore: "Más información",
  getWallet: "Obtén una billetera",
  approveInWallet: "Aprobar en la billetera",
  confirmInWallet: "Confirmar en la billetera",
  awaitingConfirmation: "A la espera de confirmación",
  signIn: "Iniciar sesión",
  signOut: "Cerrar sesión",
  signedIn: "Sesión iniciada",
  signedOut: "Sesión cerrada",
  walletNotConnected: "Billetera no conectada",

  warnings_walletSwitchingUnsupported: `Tu billetera no permite cambiar de red desde esta aplicación.`,
  warnings_walletSwitchingUnsupportedResolve: `Prueba a cambiar de red desde tu billetera.`,
  warnings_chainUnsupported: `Esta aplicación no es compatible con la red conectada actualmente.`,
  warnings_chainUnsupportedResolve: `Cambia o desconecta para continuar.`,

  onboardingScreen_heading: `Obtén una billetera`,
  onboardingScreen_h1: `Comienza a explorar la Web3`,
  onboardingScreen_p: `Tu billetera es el portal de acceso a todo lo relacionado con Ethereum, la tecnología mágica que permite explorar la Web3.`,
  onboardingScreen_ctaText: `Elige tu primera billetera`,
  onboardingScreen_ctaUrl: `https://ethereum.org/es/wallets/find-wallet/`,

  aboutScreen_heading: `Acerca de las billeteras`,
  aboutScreen_a_h1: `Para tus activos digitales`,
  aboutScreen_a_p: `Las billeteras te permiten enviar, recibir, almacenar e interactuar con activos digitales como los NFT y otros tokens de Ethereum.`,
  aboutScreen_b_h1: `Una manera mejor de iniciar sesión`,
  aboutScreen_b_p: `Con las aplicaciones modernas, puedes utilizar tu billetera para iniciar sesión fácilmente, en vez de tener que recordar una contraseña.`,
  aboutScreen_c_h1: `Explora el mundo de la Web3`,
  aboutScreen_c_p: `Tu billetera es una herramienta esencial que te permite explorar y participar en el mundo en rápida evolución de la Web3.`,
  aboutScreen_ctaText: `Más información`,
  aboutScreen_ctaUrl: `https://ethereum.org/es/wallets/`,

  connectorsScreen_heading: `Conecta una billetera`,
  connectorsScreen_newcomer: `No tengo una billetera`,
  connectorsScreen_h1: `¿Qué es una billetera?`,
  connectorsScreen_p: `Las billeteras se utilizan para enviar, recibir y almacenar activos digitales. Si conectas una billetera, podrás interactuar con las aplicaciones.`,

  mobileConnectorsScreen_heading: `Elige una billetera`,

  scanScreen_heading: `Escanea con el teléfono`,
  scanScreen_heading_withConnector: `Escanea con {{ CONNECTORNAME }}`,
  scanScreen_tooltip_default: `Abre {{ CONNECTORNAME }} en tu teléfono móvil`,

  downloadAppScreen_heading: `Obtén {{ CONNECTORNAME }}`,
  downloadAppScreen_iosAndroid: `Escanea con la cámara de tu teléfono para descargarla en iOS o Android.`,
  downloadAppScreen_ios: `Escanea con la cámara de tu teléfono para descargarla en iOS.`,
  downloadAppScreen_android: `Escanea con la cámara de tu teléfono para descargarla en Android.`,

  injectionScreen_unavailable_h1: `Navegador no compatible`,
  injectionScreen_unavailable_p: `Para conectar tu billetera de {{ CONNECTORSHORTNAME }}, instala la extensión en {{ SUGGESTEDEXTENSIONBROWSER }}.`,

  injectionScreen_install_h1: `Instala {{ CONNECTORNAME }}`,
  injectionScreen_install_p: `Para conectar tu billetera de {{ CONNECTORSHORTNAME }}, instala la extensión del navegador.`,

  injectionScreen_connecting_h1: `Solicitud de conexión`,
  injectionScreen_connecting_p: `Abre la extensión del navegador de {{ CONNECTORSHORTNAME }}  para conectar tu billetera.`,
  injectionScreen_connecting_injected_h1: `Solicitud de conexión`,
  injectionScreen_connecting_injected_p: `Acepta la solicitud a través de tu billetera para conectarte a esta aplicación.`,

  injectionScreen_connected_h1: `Ya conectada`,
  injectionScreen_connected_p: `Ya puedes cerrar esta ventana emergente`,

  injectionScreen_rejected_h1: `Solicitud cancelada`,
  injectionScreen_rejected_p: `Has cancelado la solicitud. Haz clic arriba para intentarlo de nuevo.`,

  injectionScreen_failed_h1: `Error de conexión`,
  injectionScreen_failed_p: `Lo sentimos, ha habido un problema. Intenta conectarte de nuevo.`,

  injectionScreen_notconnected_h1: `Inicia sesión en {{ CONNECTORNAME }}`,
  injectionScreen_notconnected_p: `Para continuar, inicia sesión en tu extensión de {{ CONNECTORNAME }}.`,

  profileScreen_heading: "Conectado",

  switchNetworkScreen_heading: "Cambio de red",

  signInWithEthereumScreen_tooltip:
    "No has iniciado sesión en esta aplicación.\n**Inicia sesión con Ethereum** para continuar.",
  signInWithEthereumScreen_signedOut_heading: "Inicia sesión con Ethereum",
  signInWithEthereumScreen_signedOut_h1:
    "Esta aplicación desea verificar que eres el propietario de esta billetera.",
  signInWithEthereumScreen_signedOut_p: `Firma la solicitud de mensaje en tu billetera para continuar.`,
  signInWithEthereumScreen_signedOut_button: "Iniciar sesión",

  signInWithEthereumScreen_signedIn_heading: "Sesión iniciada con Ethereum",
  signInWithEthereumScreen_signedIn_h1:
    "Te has verificado correctamente como propietario de esta billetera.",
  signInWithEthereumScreen_signedIn_p: `Si cierras la sesión, tendrás que volver a autenticarte más adelante.`,
  signInWithEthereumScreen_signedIn_button: "Cerrar sesión",
  // Nuevas traducciones para Daimo Pay y textos adicionales
  payButton_defaultLabel: "Pagar",
  insufficientBalance: "Saldo insuficiente.",
  payWith: "Pagar con",
  payWithWallet: "Pagar con billetera",
  payWithAnotherWallet: "Pagar con otra billetera",
  payWithAnotherMethod: "Pagar con otro método",
  payWithExchange: "Pagar con exchange",
  payViaPaymentApp: "Pagar con aplicación de pago",
  payToAddress: "Pagar a una dirección",
  retry: "Reintentar",
  invalidState_heading: "Estado inválido",
  invalidState_description:
    "Ningún conector coincide con el id dado. Este estado nunca debería suceder.",
  tokensAccepted: "1000+ tokens aceptados",
  yourBalances: "Tus fondos",
  on: "en",
  moreAvailable: "Más Disponible",
  other: "Otras",
  mobileWallets: "Billeteras móviles",
  mobile: "Móvil",
  poweredBy: "Impulsado por",
  scanWithPhone: "Escanea con móvil",
  selectExchange: "Selecciona un exchange",
  solanaWallet: "Billetera Solana",
  selectChain: "Selecciona una red",
  selectApp: "Selecciona una app",
  selectAmount: "Selecciona una cantidad",
  paymentSuccessful: "Pago exitoso",
  error: "Error",
  retryPayment: "Reintentar pago",
  contactSupport: "Contactar soporte",
  sendExactly: "Enviar exactamente",
  receivingAddress: "Dirección de destino",
  refresh: "Refrescar",
  waitingForPayment: "Esperando pago",
  sendOnlyOnce: "Enviar solo una vez",
  showQR: "Mostrar QR",
  hideQR: "Ocultar QR",
};

export default esES;
